import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import ThemeSwitcher from './ThemeSwitcher';
import '../styling/Header.css'

function Header() {
  return (
    <Navbar sticky="top" className="header-navbar">
      <Container>
        <Navbar.Brand href="#" className="brand-wrapper">
          <div className="brand-content">
            <span className="brand-accent">→</span>
            <h1 className="brand-name">Robin Okwanma</h1>
            <span className="brand-title">Software Engineer</span>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end">
          <div className="header-actions">
            <ThemeSwitcher />
          </div>
        </Navbar.Collapse>
      </Container>
      <div className="header-underline"></div>
    </Navbar>
  );
}

export default Header;